import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { KeycloakService } from "../security";
import { NotificationService } from "../services/notification.service";

@Injectable()
export class TokenExists {
    constructor(
        private keycloakService: KeycloakService,
        private notify: NotificationService,
    ) {}

    // always returns true, don't prevent navigation for now
    async canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot,
    ): Promise<boolean> {
        const token = await this.keycloakService.awaitExistingParsedToken();

        if (!token) {
            this.notify.error(
                "Anmeldung",
                "Es ist kein Keycloak-Token vorhanden.",
            );
        }

        return true;
    }
}

@Injectable()
export class RolesExist {
    constructor(
        private keycloakService: KeycloakService,
        private notify: NotificationService,
    ) {}

    // always returns true, don't prevent navigation for now
    async canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot,
    ): Promise<boolean> {
        const token = await this.keycloakService.awaitExistingParsedToken();
        if (!token) {
            // error already issued by TokenExists.canActivate()
            return true;
        }
        const roles =
            token.realm_access && token.realm_access.roles
                ? token.realm_access.roles
                : [];

        if (
            !roles.includes("App_Beratungsdokumentation") &&
            !roles.includes("App_Beratungsdokumentation_Austria")
        ) {
            this.notify.error(
                "Anmeldung",
                "Ihnen fehlt die benötigte Rolle 'App_Beratungsdokumentation', um auf die Beratungsdokumentation zugreifen zu können.",
            );
            return true;
        }

        if (
            roles.includes("App_Beratungsdokumentation_Share_Ou") &&
            !token.ou
        ) {
            this.notify.warning(
                "Anmeldung",
                "Ihrem Keycloak-Token fehlt die OU. Ihre Dokumentationen werden nicht mit Mitarbeitern derselben Organisationseinheit geteilt.",
            );
        }
        if (
            roles.includes("App_Beratungsdokumentation_Share_BUID") &&
            !token.buid
        ) {
            this.notify.warning(
                "Anmeldung",
                "Ihrem Keycloak-Token fehlt die BUID. Ihre Dokumentationen werden nicht mit Mitarbeitern derselben BUID geteilt.",
            );
        }

        return true;
    }
}
